import {StyleSheet} from 'react-native';

import spacing from '@/constants/spacing';
import {createThemedStyles} from '@/theme';

export const ARTIST_CARD_HEIGHT = 32;

export const styles = createThemedStyles(() => ({
  scrollContainer: {
    flex: 1,
  },
  scrollContent: {
    padding: spacing.s,
    flexGrow: 1,
  },
  optionContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  optionGroup: {
    marginBottom: spacing.s,
  },
  searchBox: {
    marginVertical: spacing.xs,
  },
  imageContainer: {
    height: ARTIST_CARD_HEIGHT,
    aspectRatio: 1,
    padding: spacing.xxs,
    justifyContent: 'center',
    alignItems: 'center',
  },
  imageWrapper: {
    ...StyleSheet.absoluteFillObject,
    height: '100%',
    width: '100%',
    borderRadius: ARTIST_CARD_HEIGHT / 2,
    overflow: 'hidden',
    justifyContent: 'center',
    alignItems: 'center',
  },
  artistInfo: {
    flexShrink: 1,
    gap: spacing.xs,
    flexDirection: 'row',
    alignItems: 'center',
  },
}));
